import { defaultSelectedCart } from './state'

export function setCart(state, cart) {
	if (!cart.documents_products){
		cart.documents_products = []
	}

    if (!cart.price_lists){
        cart.price_lists = []
    }

	state.cart = cart
	state.cartInitial = cart
}

export function setCartItems(state, items) {
	state.cart.items = items
}

export function setInformation(state, information) {
	state.cart.information = information
}

export function cartError(state, errorMessage) {
	state.errorMessage = errorMessage
}

export function setTotal(state, total){
	state.total = total
}

export function setPdf(state, pdf){
	state.pdf = pdf
}

export function addItemCart(state, item){

	let documents_products = [];

	if(state.cart.documents_products){
		documents_products = JSON.parse(JSON.stringify(state.cart.documents_products))
	}

	let index = documents_products.findIndex(dp => dp.id == item.id)

	if(index >= 0){
		documents_products.splice(index, 1, item);
	}else{
		documents_products.push(item)
	}

	state.cart.documents_products = documents_products
}

export function deleteItemCart(state, item){

	let documents_products = [];

	documents_products = JSON.parse(JSON.stringify(state.cart.documents_products))

	let index = documents_products.findIndex(dp => dp.id == item.id)

	if(index >= 0){
		documents_products.splice(index, 1);
	}

	state.cart.documents_products = documents_products
}

export function setShowPdf(state, show_pdf){

	state.show_pdf = show_pdf

}

export function setLastCart(state, last_cart){

	state.last_cart = last_cart

}

export function setFreight(state, freight){

    state.freight = freight
    state.freight.cant = 1
    // state.freight.price.percentage = 0

}

export function setContactPropartes(state, contactPropartes){

    if (contactPropartes[0]) {
        state.contactPropartes = contactPropartes[0]
    }

}

/**
 * Establecer un valor para la variable price_list_config.
 */
export function setPriceListConfig(state, price_list_config) {
    state.price_list_config = price_list_config;
}

export function setResumeCsv(state, resume_csv) {
    state.resume_csv = resume_csv;
}

export function setLoadingImportExcel (state, loading_import_excel) {
	state.loading_import_excel = loading_import_excel;
}

export function setResumeAi(state, resume_csv) {
    state.resume_ai = resume_csv;
}


// 
export function setSuggestedProductPurchaseDaysQuantities(state, ids) {
    state.suggestedProductPurchaseDaysQuantities = ids;
}

export function setSuggestedProductSeasonality(state, ids) {
    state.suggestedProductSeasonality = ids;
}

export function setSuggestedProductLastSale(state, data) {
    state.suggestedProductLastSale = data;
}

export function getSuggestedProductSalesCompany(state, data) {
    state.suggestedProductSalesCompany = data;
}

export function setResumeProductAi(state, data) {
    state.resumeProductAi = data;
}

export function setResumeProductQuantityAi(state, data) {
    state.resumeProductQuantityAi = data;
}

export function setCartSuggested(state, cart) {
  state.cart_suggested = cart;
}

export function resetCartSuggested(state) {
  state.cart_suggested = {
    documents_product: [],
    documents_information: {
      price_list: "",
    },
    price_lists: [],
  };
}

export function setCartSuggestedProducts(state, data) {
  state.cartSuggestedProducts = data;
}

export function resetSuggestedProductSelectedLocalStorage(state) {
  localStorage.removeItem("suggested_product_selected_brands");
  localStorage.removeItem("suggested_product_selected_families");
  localStorage.removeItem("suggested_product_selected_categories");
}

export function setBrandSublineCategoryRelations(state, data) {
  // state.cart_suggested.documents_product

  // state.brandSublineCategoryRelations = data;
  const relations = [
      ...new Map(
          state.cart_suggested.documents_products
              .map(item => ({
                  brand_id: item.product?.brand_id,
                  subline_id: item.product?.subline_id,
                  category_id: item.product?.category_id
              }))
              .filter(item =>
                  item.brand_id &&
                  item.subline_id &&
                  item.category_id
              )
              .map(item => [
                  `${item.brand_id}-${item.subline_id}-${item.category_id}`,
                  item
              ])
      ).values()
  ];

  state.brandSublineCategoryRelations = relations;
}
